module.exports = __webpack_public_path__ + "5b816bd6cd5b2abbdcafbfd4084aae65.png";